import React, { Component } from "react";
import NextPromptButton from "./NextPromptButton";
import "../../styles/nextprompt/NextPrompt.css";
import $ from "jquery";

var secondCardInfo = {};
secondCardInfo["about"] = {
  title: "WHO ARE WE?",
  subText: 'And what does "Callgage" even mean?',
  buttonText: "About Us",
  link: "/about"
};
secondCardInfo["seo"] = {
  title: "SEO Services",
  subText: "Yes, we provide them.",
  buttonText: "SEO Services",
  link: "/seo"
};
secondCardInfo["product"] = {
  title: "OUR WORK",
  subText: "Check out some of our recent projects.",
  buttonText:"View Work",
  link:"/product-manufacturing"
}

export default class NextPrompt extends Component {
  constructor(props) {
    super(props);
    this.currentPage = "";
    this.state = {
      secondCard: secondCardInfo["about"]
    };
  }
  componentDidMount() {
    this.handleButtonHover();
    this.currentPage = window.location.pathname;
    this.setSecondCard();
  }

  // Determine what the second card should be
  setSecondCard() {
    if (this.currentPage === "/seo") {
      this.setState({
        secondCard: secondCardInfo["about"]
      });
    } else if (this.currentPage === "/about") {
      this.setState({
        secondCard: secondCardInfo["product"]
      });
    } else {
      this.setState({
        secondCard: secondCardInfo["about"]
      });
    }
  }

  //Manually set hover state on pointing-container
  handleButtonHover() {
    $(".NextPrompt .g-button").hover(
      function() {
        $(this)
          .siblings(".pointing-container")
          .addClass("hovered");
      },
      function() {
        $(this)
          .siblings(".pointing-container")
          .removeClass("hovered");
      }
    );
  }

  render() {
    var secondCardData = this.state.secondCard;
    var secondCard = (
      <div className="card">
        <div className="g-title">{secondCardData.title}</div>
        <div className="g-sub-text">{secondCardData.subText}</div>
        <NextPromptButton
          text={secondCardData.buttonText}
          link={secondCardData.link}
        />
      </div>
    );
    return (
      <div className="NextPrompt gutters on-scroll-anim">
        <div className="section-title-container on-scroll-anim">
          <div className="section-title g-title">WHAT'S NEXT?</div>
        </div>

        {/* Desktop Card Container */}
        <div className="card-container desktop on-scroll-anim">
          {/* The Homepage Card */}
          <div className="card">
            <div className="g-title">TAKE ME HOME</div>
            <div className="g-sub-text">Country roads...</div>
            <NextPromptButton text={"Homepage"} link={"/"} />
          </div>

          {/* The Other Page */}
          {secondCard}
        </div>

        {/* Mobile View */}
        <div className="sub-text g-sub-text mobile on-scroll-anim">
          Choose wisely...
        </div>
        <div className="button-wrapper mobile on-scroll-anim">
          <NextPromptButton text={"Homepage"} link="/" />
          <NextPromptButton
            text={secondCardData.buttonText}
            link={secondCardData.link}
          />
        </div>
      </div>
    );
  }
}
